import * as fromDatatype from '../datatype-library/index';

export interface bl_mlm_entity_contact_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    parent_entity_guid: fromDatatype.GuidDataFieldInterface;
    email: fromDatatype.VarcharDatatypeInterface;
    phone: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_mlm_entity_contact_hdr_RowClass implements bl_mlm_entity_contact_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    parent_entity_guid: fromDatatype.GuidDataFieldInterface;
    email: fromDatatype.VarcharDatatypeInterface;
    phone: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}